import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ChangeRequestDataObject } from 'models/service';

type GetChangeRequestParams = {
  changeRequestId: string;
  invitationToken: string;
};

export const getChangeRequest = async ({ changeRequestId, invitationToken }: GetChangeRequestParams) =>
  apiClient.get<ChangeRequestDataObject, ApiClientResponse<ChangeRequestDataObject>>(
    routes.changeRequests.get(changeRequestId),
    {
      params: { invitation_token: invitationToken },
    },
  );
